import type { AgeChipId } from "@/lib/blog/age-bands";

/**
 * Reading-path order per age chip. ORDER PENDING DR. SARA'S SIGN-OFF.
 * Listed slugs come first in this order; the remaining matching posts follow,
 * newest first. Unpublished or deleted slugs are skipped.
 */
const START = "dimagh-tiflik-1-6";

export const BLOG_PATHS: Record<AgeChipId, string[]> = {
  "1-2": [START],
  "2-3": [
    START,
    "tarbiyat-al-tifl-sana-wa-nisf",
    "nawm-al-tifl",
    "al-tifl-al-anid",
    "tifli-yadribni",
    "al-shashat-wa-dimagh-al-tifl",
    "tifli-la-yuabbir-an-mashaerih",
    "al-tadreeb-ala-al-hammam",
    "tadakhul-al-ahl-fi-al-tarbiya",
  ],
  "3-4": [START],
  "4-6": [START],
  "6-8": [START],
  "8-10": [START],
};
